import AboutProduct from "./parts/AboutProduct";
import AboutSelfSchool from "./parts/AboutSelfSchool";
import Banner from "./parts/Banner";
import Benefits from "./parts/Benefits";
import GeneralDirector from "./parts/GeneralDirector";
import OurVision from "./parts/OurVision";
import WhoAreWe from "./parts/WhoAreWe";
import { MainPagesLayout } from "../../../../containers/MainPagesLayout";

const AboutUsView = () => {
	return (
		<MainPagesLayout>
			<Banner />
			<WhoAreWe />
			<OurVision />
			<AboutSelfSchool />
			<Benefits />
			<AboutProduct />
			<GeneralDirector />
		</MainPagesLayout>
	);
};

export default AboutUsView;
